<template>
	<div>
		<Row>
			<Col span="24">
				<ActionBar>
					<ActionBarIcon icon="add-o" text="Новая" :to="{name: 'new-appointment'}" :class="{ hidden: !isAuthenticated, active: isActive('new-appointment') }" />
					<ActionBarIcon icon="records" text="Записи" :to="{name: 'appointments'}" :class="{ hidden: !isAuthenticated, active: isActive('appointments') }" />
					<router-link class="logo" :to="{name: 'home'}">
						Med Planner
					</router-link>
					<ActionBarIcon icon="setting-o" text="Настройки" :to="{name: 'icons'}" class="hidden"/>
					<ActionBarIcon icon="close" text="Выйти" :class="{ hidden: !isAuthenticated }" @click="onLogout"/>
				</ActionBar>
			</Col>
		</Row>
		<Row class="top-row" justify="center">
			<Col span="24" class="main-container">
				<router-view></router-view>
			</Col>
		</Row>
	</div>
</template>

<script>
import { ActionBar, ActionBarIcon, Col, Row } from 'vant';
import { useUserStore } from '@/stores/user';

export default {
	name: 'App',
	components: {
		ActionBar,
		ActionBarIcon,
		Col, Row,
	},
	computed: {
		isAuthenticated() {
			return useUserStore().isAuthenticated;
		},
	},
	beforeCreate() {
		useUserStore();
	},
	methods: {
		onLogout() {
			useUserStore().logout();
			this.$router.push({ name: 'home' });
		},
		isActive(linkName) {
			return this.$route.name === linkName;
		},
	}
}
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.logo {
	flex-grow: 1;
	text-align: center;
	color: black;
}
</style>

<style scoped>
.active {
	background-color: var(--active-menu-color);
}
</style>
